import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove any injected badges
function removeBadges() {
  const selectors = ['#emergent-badge', '[data-emergent-badge]', 'a[href*="emergent.sh"]'];
  selectors.forEach(s => { document.querySelectorAll(s).forEach(el => el.remove()); });
}
removeBadges();
const observer = new MutationObserver(removeBadges);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
